import api from "./api";

export interface Client {
  id: number;
  key: string;
  name: string;
  description: string;
  createAt: string;
  url: string;
}

export interface CreateClientRequest {
  name: string;
  description: string;
  url: string;
}
export interface UpdateClientRequest extends CreateClientRequest {
  id: number;
}

export const clientsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getClients: builder.query<Client[], void>({
      query: () => ({
        url: "clients",
        method: "get",
      }),
      providesTags: (results) =>
        results
          ? [
              ...results.map(({ id }) => ({ type: "clients" as const, id })),
              { type: "clients", id: "LIST" },
            ]
          : [{ type: "clients", id: "LIST" }],
    }),
    createClient: builder.mutation<unknown, CreateClientRequest>({
      query: ({ description, name, url }) => ({
        url: "clients",
        method: "post",
        body: { description, name, url },
      }),
      invalidatesTags: [{ type: "clients", id: "LIST" }],
    }),
    updateClient: builder.mutation<unknown, UpdateClientRequest>({
      query: ({ id, description, name, url }) => ({
        url: `clients/${id}`,
        method: "put",
        body: { description, name, url },
      }),
      invalidatesTags: [{ type: "clients", id: "LIST" }],
    }),
    removeClient: builder.mutation<unknown, number>({
      query: (id) => ({
        url: `clients/${id}`,
        method: "delete",
      }),
      invalidatesTags: [{ type: "clients", id: "LIST" }],
    }),
  }),
});

export const {
  useGetClientsQuery,
  useCreateClientMutation,
  useRemoveClientMutation,
  useUpdateClientMutation,
} = clientsApi;
